const environmentConfig = { ...window.envtConfig, ...window.resourcesConfig };

export default environmentConfig;
